import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const ArrowTrendingUpIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/arrow-trending-up"><path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M15.0923 5.85399C15.221 5.37387 15.7145 5.08895 16.1946 5.2176L21.9319 6.7549C22.1625 6.81668 22.3591 6.96752 22.4784 7.17424C22.5978 7.38095 22.6301 7.62661 22.5683 7.85717L21.031 13.5945C20.9024 14.0746 20.4089 14.3595 19.9287 14.2309C19.4486 14.1022 19.1637 13.6087 19.2923 13.1286L20.2637 9.50338C17.5563 11.1716 15.3048 13.3081 13.5521 15.7466C13.398 15.9611 13.1575 16.097 12.8942 16.1184C12.631 16.1398 12.3717 16.0445 12.1849 15.8578L8.39995 12.0728L2.73635 17.7364C2.38488 18.0879 1.81503 18.0879 1.46356 17.7364C1.11208 17.3849 1.11208 16.8151 1.46356 16.4636L7.76355 10.1636C8.11503 9.81213 8.68488 9.81213 9.03635 10.1636L12.7247 13.8519C14.5258 11.5566 16.756 9.54071 19.379 7.93435L15.7287 6.95626C15.2486 6.82762 14.9637 6.33411 15.0923 5.85399Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ArrowTrendingUpIcon;